import React, { useEffect, useState } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import DataTable from "react-data-table-component";

//Components
import Layout from "../../../../Layout/Layout";

import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";

// import SuccessModal from "../../../../Components/Modal/supplier_app/SuccessModal";
import { InputField } from "../../../../Components/formElements/InputField";
import RichTextEditor from "../../../../Components/Editor/RichTextEditor";

const MaterilPriceBreakDownDetail = () => {
  // const dispatch = useDispatch();

  localStorage.setItem("menu", "Material BreakdownV4");
  localStorage.setItem("submenu", "");

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  // eslint-disable-next-line
  const [disabled, setDisabled] = useState(true);

  const [formInputs, setFormInputs] = useState({
    dateJobEnteredSales: "",
    dateJobEnteredFirm: "",
    salesPersonCode: "",
    customer: "",
    customerNo: "",
    endUser: "",
    nonIdenticalBuildings: "",
    totalBuildings: "",
    roofArea: "",
    paymentTermsLC: "",
    paymentTermsBG: "",
    paymentTermsOthers: "",
    ccoChangeOrderNo: "",
    engineeringComplexity: "",
    approvalEngineering: "",
    productionEngineering: "",
    quoteNo: "",
    templateBasic: "",
    sellingOffice: "",
    receivingOffice: "",
    receivingTerritory: "",
    erector: "",
    mezzArea: "",
    estimatingEngineer: "",
    eOMSupervisor: "",
    eOMManager: "",
    approvalDate: "",
    remarks: "",
  });

  /* style start */
  const tableStyle = {
    borderCollapse: "collapse",
    width: "100%",
    fontFamily: "Arial, sans-serif",
  };

  const thStyle = {
    border: "1px solid #ddd",
    textAlign: "left",
    padding: "8px",
    backgroundColor: "#f2f2f2",
    fontWeight: "bold",
  };

  const tdStyle = {
    border: "1px solid #ddd",
    textAlign: "left",
    padding: "8px",
  };

  // const evenRowStyle = {
  //   backgroundColor: "#f9f9f9",
  // };
  /* style end */

  const rows = [
    { item: "1", supplyCode: "3", desc: "Anchor Bolts" },
    { item: "2", supplyCode: "1A", desc: "Built up (BU) sections" },
    { item: "3", supplyCode: "1A", desc: "Hot rolled (HR) sections" },
    { item: "4", supplyCode: "1A", desc: "Square Tube (RT) sections" },
    { item: "5", supplyCode: "1B", desc: "Cold Form Sections" },
    { item: "6", supplyCode: "1D", desc: "Sheets" },
    {
      item: "7",
      supplyCode: "1E",
      desc: "Gutters, Downspouts, Trims, flashings, Ridge etc",
    },
    { item: "8", supplyCode: "4", desc: "Valley Gutters" },
    { item: "9", supplyCode: "1F", desc: "Tempcorn Panels" },
    { item: "10", supplyCode: "1C", desc: "Sundry Parts" },
    { item: "11", supplyCode: "4", desc: "Flange Braces" },
    { item: "12", supplyCode: "4", desc: "Clips & Bent Plates" },
    { item: "13", supplyCode: "4", desc: "Misc." },
    { item: "14", supplyCode: "4", desc: "Space Frame components" },
    {
      item: "15",
      supplyCode: "4",
      desc: "Chords, Nodes, Connections (without powder coating)",
    },
    {
      item: "16",
      supplyCode: "1G",
      desc: "Open Web Joist",
      children: [
        {
          sub: "A",
          desc: "Diagonals, Misc. Connections (without powder coating)",
          supply: "4",
        },
        {
          sub: "B",
          desc: "Chords Misc. Connections (without powder coating)",
          supply: "1G",
        },
      ],
    },
    { item: "17", supplyCode: "1j", desc: "Shot Blasting" },
    { item: "18", supplyCode: "1K", desc: "Sweep Blasting" },
    { item: "19", supplyCode: "1A", desc: "Painting" },
    { item: "20", supplyCode: "1B", desc: "Secondary Steel Members" },
    { item: "21", supplyCode: "3", desc: "Connection Bolts" },
    { item: "22", supplyCode: "3", desc: "Mastic" },
    { item: "23", supplyCode: "3", desc: "Fasteners" },
    { item: "24", supplyCode: "1C", desc: "Cage Ladders" },
    { item: "25", supplyCode: "1C", desc: "Ridge Vents" },
    { item: "26", supplyCode: "4", desc: "Sliding Doors" },
    { item: "27", supplyCode: "4", desc: "Mezzanine Decking" },
    { item: "28", supplyCode: "4", desc: "Flooring" },
    { item: "29", supplyCode: "4", desc: "Stairs" },
    { item: "30", supplyCode: "5A", desc: "Handrails" },
    { item: "31", supplyCode: "5B", desc: "Insulation" },
    { item: "32", supplyCode: "5B", desc: "Translucent Panels" },
    { item: "33", supplyCode: "5B", desc: "Pipe Flashing" },
    { item: "34", supplyCode: "5B", desc: "Doors" },
    { item: "35", supplyCode: "5B", desc: "Steel Louvers" },
    { item: "36", supplyCode: "5B", desc: "Fiberglass" },
    { item: "37", supplyCode: "5B", desc: "Power Vents" },
    { item: "38", supplyCode: "5B", desc: "Roll Up Doors" },
    { item: "39", supplyCode: "5B", desc: "PVC Pipes" },
    { item: "40", supplyCode: "5B", desc: "Bird Screen" },
    { item: "41", supplyCode: "5B", desc: "Aluminum Windows" },
    { item: "42", supplyCode: "6A", desc: "Special Buyouts" },
    { item: "43", supplyCode: "6B", desc: "Special Works (Sub Contract)" },
    { item: "44", supplyCode: "6C", desc: "Undiscountables" },
    { item: "45", supplyCode: "", desc: "Total Ex-work" },
  ];

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  const handleTextChange = (data) => {
    // setFormInputs((prev) => ({
    //   ...prev,
    //   remarks: data,
    // }));
  };

  const loadFirstLevelData = () => {
    setFormInputs({
      dateJobEnteredSales: "30-Oct-1985",
      dateJobEnteredFirm: "2025-07-08",
      salesPersonCode: "In illum nemo sint",
      customer: "Possimus nostrum do",
      customerNo: "In cumque iste conse",
      endUser: "Rem incidunt quam n",
      nonIdenticalBuildings: "Quis a voluptatem n",
      totalBuildings: "Nulla nisi eos non ",
      roofArea: "At doloribus est ips",
      paymentTermsLC: "Impedit quos ipsum",
      paymentTermsBG: "Inventore et et dese",
      paymentTermsOthers: "Voluptatem rerum qui",
      ccoChangeOrderNo: "Consequat Unde recu",
      engineeringComplexity: "Qui laborum veritati",
      approvalEngineering: "Quia sunt amet volu",
      productionEngineering: "Adipisicing eum in s",
      quoteNo: "Amet anim enim repr",
      templateBasic: "Itaque in et ratione",
      sellingOffice: "Sed sunt qui proiden",
      receivingOffice: "Nihil voluptas fugia",
      receivingTerritory: "Ex magni voluptatem",
      erector: "Voluptates consequat",
      mezzArea: "Ut aute est ratione ",
      estimatingEngineer: "Laboriosam nihil re",
      eOMSupervisor: "Fugiat eveniet ea ",
      eOMManager: "Modi rem vero sed ut",
      approvalDate: "2025-07-08",
      remarks: "<p>Molestiae non commod.</p>",
      jobNo: "Asperiores debitis a",
      dateJobEnteredMFS: "2025-07-08",
      rows: [
        {
          item: "1",
          supplyCode: "3",
          desc: "Anchor Bolts",
        },
        {
          item: "2",
          supplyCode: "1A",
          desc: "Built up (BU) sections",
        },
        {
          item: "3",
          supplyCode: "1A",
          desc: "Hot rolled (HR) sections",
        },
        {
          item: "4",
          supplyCode: "1A",
          desc: "Square Tube (RT) sections",
        },
        {
          item: "5",
          supplyCode: "1B",
          desc: "Cold Form Sections",
        },
        {
          item: "6",
          supplyCode: "1D",
          desc: "Sheets",
        },
        {
          item: "7",
          supplyCode: "1E",
          desc: "Gutters, Downspouts, Trims, flashings, Ridge etc",
        },
        {
          item: "8",
          supplyCode: "4",
          desc: "Valley Gutters",
        },
        {
          item: "9",
          supplyCode: "1F",
          desc: "Tempcorn Panels",
        },
        {
          item: "10",
          supplyCode: "1C",
          desc: "Sundry Parts",
        },
        {
          item: "11",
          supplyCode: "4",
          desc: "Flange Braces",
        },
        {
          item: "12",
          supplyCode: "4",
          desc: "Clips & Bent Plates",
        },
        {
          item: "13",
          supplyCode: "4",
          desc: "Misc.",
        },
        {
          item: "14",
          supplyCode: "4",
          desc: "Space Frame components",
        },
        {
          item: "15",
          supplyCode: "4",
          desc: "Chords, Nodes, Connections (without powder coating)",
        },
        {
          item: "16",
          supplyCode: "1G",
          desc: "Open Web Joist",
          children: [
            {
              sub: "A",
              desc: "Diagonals, Misc. Connections (without powder coating)",
              supply: "4",
            },
            {
              sub: "B",
              desc: "Chords Misc. Connections (without powder coating)",
              supply: "1G",
            },
          ],
        },
        {
          item: "17",
          supplyCode: "1j",
          desc: "Shot Blasting",
        },
        {
          item: "18",
          supplyCode: "1K",
          desc: "Sweep Blasting",
        },
        {
          item: "19",
          supplyCode: "1A",
          desc: "Painting",
        },
        {
          item: "20",
          supplyCode: "1B",
          desc: "Secondary Steel Members",
        },
        {
          item: "21",
          supplyCode: "3",
          desc: "Connection Bolts",
        },
        {
          item: "22",
          supplyCode: "3",
          desc: "Mastic",
        },
        {
          item: "23",
          supplyCode: "3",
          desc: "Fasteners",
        },
        {
          item: "24",
          supplyCode: "1C",
          desc: "Cage Ladders",
        },
        {
          item: "25",
          supplyCode: "1C",
          desc: "Ridge Vents",
        },
        {
          item: "26",
          supplyCode: "4",
          desc: "Sliding Doors",
        },
        {
          item: "27",
          supplyCode: "4",
          desc: "Mezzanine Decking",
        },
        {
          item: "28",
          supplyCode: "4",
          desc: "Flooring",
        },
        {
          item: "29",
          supplyCode: "4",
          desc: "Stairs",
        },
        {
          item: "30",
          supplyCode: "5A",
          desc: "Handrails",
        },
        {
          item: "31",
          supplyCode: "5B",
          desc: "Insulation",
        },
        {
          item: "32",
          supplyCode: "5B",
          desc: "Translucent Panels",
        },
        {
          item: "33",
          supplyCode: "5B",
          desc: "Pipe Flashing",
        },
        {
          item: "34",
          supplyCode: "5B",
          desc: "Doors",
        },
        {
          item: "35",
          supplyCode: "5B",
          desc: "Steel Louvers",
        },
        {
          item: "36",
          supplyCode: "5B",
          desc: "Fiberglass",
        },
        {
          item: "37",
          supplyCode: "5B",
          desc: "Power Vents",
        },
        {
          item: "38",
          supplyCode: "5B",
          desc: "Roll Up Doors",
        },
        {
          item: "39",
          supplyCode: "5B",
          desc: "PVC Pipes",
        },
        {
          item: "40",
          supplyCode: "5B",
          desc: "Bird Screen",
        },
        {
          item: "41",
          supplyCode: "5B",
          desc: "Aluminum Windows",
        },
        {
          item: "42",
          supplyCode: "6A",
          desc: "Special Buyouts",
        },
        {
          item: "43",
          supplyCode: "6B",
          desc: "Special Works (Sub Contract)",
        },
        {
          item: "44",
          supplyCode: "6C",
          desc: "Undiscountables",
        },
        {
          item: "45",
          supplyCode: "",
          desc: "Total Ex-work",
        },
      ],
    });
  };

  useEffect(() => {
    loadFirstLevelData();
  }, []);

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} lg={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col>
                <Col xs={12} md={12} lg={12}>
                  <h2 className="mainTitle">MATERIAL PRICE BREAKDOWN</h2>
                  <p className="subText">Material Price Breakdown Details</p>
                </Col>
              </Col>
            </Row>

            <hr />

            {/* <Row className="mb-4">
              <Col xs={12} md={2} lg={2} className="d-flex justify-content-end">
                <>
                  <button className="btnBack">save</button>
                </>
              </Col>
            </Row> */}

            {/*  details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">MP</span>
                    </Col>

                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle">
                        {" "}
                        MATERIAL PRICE BREAKDOWN{" "}
                      </span>
                      <span className="subHeaderTitle">
                        MATERIAL PRICE BREAKDOWN{" "}
                      </span>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Job No"
                                name="jobNo"
                                id="jobNo"
                                value={formInputs?.jobNo}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Date Job Entered in MFS"
                                type="date"
                                name="dateJobEnteredMFS"
                                id="dateJobEnteredMFS"
                                value={formInputs?.dateJobEnteredMFS}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Date Job Entered in Sales"
                                name="dateJobEnteredSales"
                                id="dateJobEnteredSales"
                                value={formInputs?.dateJobEnteredSales}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Date Job Entered Firm"
                                type="date"
                                name="dateJobEnteredFirm"
                                id="dateJobEnteredFirm"
                                value={formInputs?.dateJobEnteredFirm}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Sales Person Code"
                                name="salesPersonCode"
                                id="salesPersonCode"
                                value={formInputs?.salesPersonCode}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Customer"
                                name="customer"
                                id="customer"
                                value={formInputs?.customer}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Customer No"
                                name="customerNo"
                                id="customerNo"
                                value={formInputs?.customerNo}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="End User"
                                name="endUser"
                                id="endUser"
                                value={formInputs?.endUser}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="No. of non identical Bldgs"
                                name="nonIdenticalBuildings"
                                id="nonIdenticalBuildings"
                                value={formInputs?.nonIdenticalBuildings}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total no of Buildings"
                                name="totalBuildings"
                                id="totalBuildings"
                                value={formInputs?.totalBuildings}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Roof Area (m²)"
                                name="roofArea"
                                id="roofArea"
                                value={formInputs?.roofArea}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Payment Terms - L/C"
                                name="paymentTermsLC"
                                id="paymentTermsLC"
                                value={formInputs?.paymentTermsLC}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Payment Terms - BG"
                                name="paymentTermsBG"
                                id="paymentTermsBG"
                                value={formInputs?.paymentTermsBG}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Payment Terms - Others (Specify)"
                                name="paymentTermsOthers"
                                id="paymentTermsOthers"
                                value={formInputs?.paymentTermsOthers}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Includes all CCO through Change Order No"
                                name="ccoChangeOrderNo"
                                id="ccoChangeOrderNo"
                                value={formInputs?.ccoChangeOrderNo}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Engineering Complexity"
                                name="engineeringComplexity"
                                id="engineeringComplexity"
                                value={formInputs?.engineeringComplexity}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Approval Engineering"
                                name="approvalEngineering"
                                id="approvalEngineering"
                                value={formInputs?.approvalEngineering}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Production Engineering"
                                name="productionEngineering"
                                id="productionEngineering"
                                value={formInputs?.productionEngineering}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Quote No"
                                name="quoteNo"
                                id="quoteNo"
                                value={formInputs?.quoteNo}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Template Basic"
                                name="templateBasic"
                                id="templateBasic"
                                value={formInputs?.templateBasic}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Selling Office"
                                name="sellingOffice"
                                id="sellingOffice"
                                value={formInputs?.sellingOffice}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Receiving Office"
                                name="receivingOffice"
                                id="receivingOffice"
                                value={formInputs?.receivingOffice}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Receiving Territory"
                                name="receivingTerritory"
                                id="receivingTerritory"
                                value={formInputs?.receivingTerritory}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Erector"
                                name="erector"
                                id="erector"
                                value={formInputs?.erector}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Mezz Area (m²)"
                                name="mezzArea"
                                id="mezzArea"
                                value={formInputs?.mezzArea}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/*  details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">MT</span>
                    </Col>

                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle">
                        {" "}
                        MATERIAL PRICE BREAKDOWN TABLE{" "}
                      </span>
                      <span className="subHeaderTitle">
                        Material Price Breakdown Table{" "}
                      </span>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          {/*Table*/}
                          <div className="accordion-body autoScroll">
                            <Row>
                              <Col xs={12} md={12} lg={12}>
                                <div className="generatedTable width-100">
                                  <table style={tableStyle}>
                                    <thead>
                                      <tr>
                                        <th style={thStyle} rowSpan="2">
                                          Items No.
                                        </th>
                                        <th style={thStyle} rowSpan="2">
                                          Description
                                        </th>
                                        <th style={thStyle} rowSpan="2">
                                          Supply code
                                        </th>
                                        <th
                                          style={thStyle}
                                          colSpan="2"
                                          className="text-center"
                                        >
                                          Weight
                                        </th>
                                        <th style={thStyle} rowSpan="2">
                                          Book Price (INR)
                                        </th>
                                        <th style={thStyle} rowSpan="2">
                                          Discount (%)
                                        </th>
                                        <th style={thStyle} rowSpan="2">
                                          Selling Price (INR)
                                        </th>
                                        <th style={thStyle} rowSpan="2">
                                          Sold Rate (INR / MT)
                                        </th>
                                        <th style={thStyle} rowSpan="2">
                                          Discount (%)
                                        </th>
                                        <th style={thStyle} rowSpan="2">
                                          By :
                                        </th>
                                      </tr>
                                      <tr>
                                        <th style={thStyle}>Total (MT)</th>
                                        <th style={thStyle}>% of Total</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {rows.map((row) => (
                                        <React.Fragment key={row.item}>
                                          {/* main row */}
                                          <tr>
                                            <td style={tdStyle}>{row.item}</td>
                                            <td style={tdStyle}>
                                              <strong>{row.desc}</strong>
                                            </td>
                                            <td style={tdStyle}>
                                              {row.supplyCode || ""}
                                            </td>
                                            <td style={tdStyle}>
                                              {/* <InputField
                                                className="inputBox"
                                                label=""                                               
                                                name="totalMetricTons"
                                                id="totalMetricTons"
                                                value={
                                                  row?.totalMetricTons
                                                }
                                                onChange={onInputChange}
                                              /> */}
                                            </td>
                                            <td style={tdStyle}>#DIV/0!</td>
                                            <td style={tdStyle}></td>
                                            <td style={tdStyle}></td>
                                            <td style={tdStyle}></td>
                                            <td style={tdStyle}></td>
                                            <td style={tdStyle}></td>
                                            <td style={tdStyle}></td>
                                          </tr>

                                          {/* child rows */}
                                          {row.children &&
                                            row.children.map((child, idx) => (
                                              <tr
                                                key={row.item + "-" + child.sub}
                                              >
                                                <td
                                                  style={{
                                                    ...tdStyle,
                                                    paddingLeft: "20px",
                                                  }}
                                                >
                                                  {child.sub}
                                                </td>
                                                <td style={tdStyle}>
                                                  {child.desc}
                                                </td>
                                                <td style={tdStyle}>
                                                  {child.supply}
                                                </td>
                                                <td style={tdStyle}></td>
                                                <td style={tdStyle}>#DIV/0!</td>
                                                <td style={tdStyle}></td>
                                                <td style={tdStyle}></td>
                                                <td style={tdStyle}></td>
                                                <td style={tdStyle}></td>
                                                <td style={tdStyle}></td>
                                                <td style={tdStyle}></td>
                                              </tr>
                                            ))}
                                        </React.Fragment>
                                      ))}

                                      {/* <tr>
                                        <td style={tdStyle}>Total Ex-work</td>
                                        <td style={tdStyle}>
                                          <strong>header</strong>
                                        </td>
                                        <td style={tdStyle}>
                                          <span>123</span>
                                        </td>
                                        <td style={tdStyle}></td>
                                        <td style={tdStyle}>#DIV/0!</td>
                                        <td style={tdStyle}></td>
                                        <td style={tdStyle}></td>
                                        <td style={tdStyle}></td>
                                        <td style={tdStyle}></td>
                                        <td style={tdStyle}></td>
                                        <td style={tdStyle}></td>
                                      </tr> */}
                                    </tbody>
                                  </table>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Instructions 10*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RE</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Remarks</span>
                      <span className="subHeaderTitle">Remarks Section</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="p-4">
                      <Col xs={12} md={12} lg={12}>
                        <RichTextEditor
                          value={formInputs?.remarks}
                          readOnly={disabled}
                          onChange={handleTextChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* invoice details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AS</span>
                    </Col>

                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Approval Section</span>
                      <span className="subHeaderTitle">Approval Section</span>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Estimating Engineer"
                                name="estimatingEngineer"
                                id="estimatingEngineer"
                                value={formInputs?.estimatingEngineer}
                                disabled={disabled}
                                onChange={onInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="EOM Supervisor"
                                name="eOMSupervisor"
                                id="eOMSupervisor"
                                value={formInputs?.eOMSupervisor}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="EOM Manager"
                                name="eOMManager"
                                id="eOMManager"
                                value={formInputs?.eOMManager}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Approval Date"
                                name="approvalDate"
                                id="approvalDate"
                                type="date"
                                value={formInputs?.approvalDate}
                                onChange={onInputChange}
                                disabled={disabled}
                              />
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default MaterilPriceBreakDownDetail;
